<template>
    <div class="overflow-hidden mt-5">
        <template v-if="showing === 'all'">
            <div @click="backToMedia" class="mb-5 flex items-center cursor-pointer">
                <BackArrow class="mr-2"/>
                <span class="text-customGray">Back</span>
            </div>
            <div class="flex flex-wrap">
                <div :class="item.files.length == 1 ? 'w-full' :'w-6/12 p-2'" v-for="file in item.files" v-bind:key="file.path" class="rounded-md mb-6">
                    <video
                        v-on:click="selectVideo(file)"
                        v-if="file.mime_type.includes('video')"
                        class="rounded-md w-full cursor-pointer"
                        @mouseleave="stop($event)"
                        @mouseenter="play($event)"
                        muted
                        loop
                    >
                        <source :src="file.url" :type="file.mime_type">
                        Your browser does not support the video tag.
                    </video>
                    <div v-if="file && file.mime_type && file.mime_type.includes('image') && file && file.url" class="w-full relative">
                        <div v-on:click="selectPhoto(file)" :class="item.files.length == 1 ? 'h-80' :'h-40'"  class="rounded-md w-full hover:opacity-30  transition-all ease-in cursor-pointer bg-center bg-cover" :style="`background-image: url(${file.url})`"></div>
                        <div v-if="loading" class="absolute top-0 right-0 h-80 w-full flex justify-center items-center">
                            <vue-loading type="bubbles" color="#e5e7ec" :size="{ width: '60px', height: '60px' }"></vue-loading>
                        </div>
                    </div>
                </div> 
            </div>
            
        </template>

        <template v-if="showing === 'single'">
            <div @click="backToAllPhotos" class="mb-5 flex items-center cursor-pointer">
                <BackArrow class="mr-2"/>
                <span class="text-customGray">Back to "{{item.name}}" {{item.type}}</span>
            </div>
            <div class="w-full bg-gray-500 rounded-md mb-6">
                <div v-if="singleItem && singleItem.url && singleItem.mime_type && singleItem.mime_type.includes('image')" class="w-full relative">
                    <img :src="singleItem.url" alt="Selected image" lazy="loading" class="rounded-md w-full max-h-116"/>
                    <div v-if="loading" class="absolute top-0 right-0 h-80 w-full h-full flex justify-center items-center">
                        <vue-loading type="bubbles" color="#e5e7ec" :size="{ width: '60px', height: '60px' }"></vue-loading>
                    </div>
                </div>
                <video
                    v-if="singleItem && singleItem.mime_type && singleItem.mime_type.includes('video')"
                    class="rounded-md w-full cursor-pointer"
                    @mouseleave="stop($event)"
                    @mouseenter="play($event)"
                    muted
                    loop
                >
                    <source :src="singleItem.url" :type="singleItem.mime_type && singleItem.mime_type !== 'video/quicktime' ? singleItem.mime_type : 'video/mp4'">
                    Your browser does not support the video tag.
                </video>
            </div> 
        </template>
        
    </div>
</template>

<script>
import { VueLoading } from 'vue-loading-template';
import BackArrow from '@/components/svg/BackArrow';

export default {    
    name:"ItemPhotos",
    
    components: {
        BackArrow,
        VueLoading
    }, 

    data () {
        return {
            showing: 'all',
            singleItem: {},
            videoAudioChannels: 0
        }
    },
    
    props: {
        item: {
            type: Object,
            require: true 
        },
    
        videoRestriction: {
            type: Object,
            require:true
        },
        
        loading: {
            type: Boolean,
            default: false
        }
    },
    
    methods: {
        backToMedia() {
            this.singlePhoto = '';
            this.$emit('select-photo', '');
            this.$emit('back-to-media');
        },

        selectPhoto(photo) {
            this.showing = 'single';
            this.singleItem = photo;
            this.$emit('select-photo', photo.url);
        },

        selectVideo(video) {
            if ((video.duration / 60) >= this.videoRestriction.duration) {
                this.$emit('video-not-selectible');
                return;
            }

            this.getData(video.url);

            this.showing = 'single';
            this.singleItem = video;
            this.$emit('select-video', {url: video.url, duration: (video.duration / 60)});
        },

        getData(videoSource) {
            let audioCtx = new AudioContext(); 
            var request = new XMLHttpRequest();
            request.open('GET', videoSource , true);
            request.responseType = 'arraybuffer';

            request.onload = () => {
                var audioData = request.response;

                audioCtx.decodeAudioData(audioData, (buffer) => {
                    
                    this.videoAudioChannels = buffer.numberOfChannels;
                    return buffer.numberOfChannels;
                })
            }
            request.send();
        },

        backToAllPhotos() {
            this.showing = 'all';
            this.singleItem = '';
            this.videoAudioChannels = 0;
            this.$emit('select-photo', '');
            this.$emit('select-video', '');
        },

        play(event) {
            event.target.play();
        },
        stop(event) {
            event.target.pause();
        },
    } ,

    mounted () {
        if(this.item.files.length == 1){
            let mediaFile = this.item.files[0]

            if(mediaFile.mime_type.includes('image')) {
                this.selectPhoto(mediaFile);
            }

            if(mediaFile.mime_type.includes('video')) {
                this.selectVideo(mediaFile);
            }
        }
    },

    watch: {
    videoAudioChannels: function (newChannels, oldChannels) {
      if(this.videoRestriction.maxAudioChannels < newChannels) {
          this.$emit('video-not-selectible');
          this.$emit('select-video', '');
          this.backToAllPhotos();
      } else {
          this.$emit('actual-video-audio-channels', newChannels);
      }
    }
  },
 }

    
</script>
